const CLIENT_PARAM = 'client';

const CONCIERGE_PARAM = 'concierge';

const MEMBER_PARAM = 'member';

const APP_ROUTES = {
  home: '/',
  applicants: '/applicants',
  applicant: (applicantID: string) => `/applicants/${applicantID}`,
  myApplicants: '/my-applicants',
  allApplicants: '/all-applicants',
  myInterviews: '/my-interviews',
  allInterviews: '/all-interviews',
  backgroundCheck: '/background-check',
  furtherReview: '/further-review',
  finalApproval: '/final-approval',
  myClients: '/my-clients',
  mySingles: '/my-singles',
  memberClients: '/members/clients',
  memberSingles: '/members/singles',
  createRec: '/create-rec',
  messages: '/messages',
  messagesForMember: (memberID: string) => `/messages?${MEMBER_PARAM}=${memberID}`,
  memberRecord: (memberID: string) => `/members/${memberID}`,
  invitations: '/invitations',
  invitation: (inviteID: string) => `/invitations/${inviteID}`,
  createRecForClient: (clientID: string) => `/create-rec?${CLIENT_PARAM}=${clientID}`,
  conciergeBook: (conciergeID: string) => `/all-clients?${CONCIERGE_PARAM}=${conciergeID}`,
} as const;

export {
  APP_ROUTES,
  CLIENT_PARAM,
  CONCIERGE_PARAM,
  MEMBER_PARAM,
};
